export const DEFAULT_MAX_PARTY_SIZE = 6;
